// extracted by mini-css-extract-plugin
export var printerCard = "_b3-1";
export var printerCardConfigured = "_b3-2";
export var printerCardError = "_b3-3";
export var printerCardsContainer = "_b3-0";
export var printerIcon = "_b3-8";
export var printerIconConfigured = "_b3-5";
export var printerIconContainer = "_b3-4";
export var printerIconError = "_b3-6";
export var printerIconUnconfigured = "_b3-7";
export var workstationsTableCard = "_b3-9";